import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import {
  getIsLoading,
  getError,
  getResetMessage,
  handlePasswordReset,
  updateResetMessage
} from "containers/Login/reducer";

import Reset from "components/Reset/Reset";

class ResetContainer extends React.PureComponent {
  render() {
    return <Reset {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  handlePasswordReset: (username) => dispatch(handlePasswordReset(username)),
  updateResetMessage: (message) => dispatch(updateResetMessage(message))
});

const mapStateToProps = (state) => ({
  isLoading: getIsLoading(state),
  resetMessage: getResetMessage(state),
  error: getError(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ResetContainer);
